import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useAnalytics } from "utils";

const RetryModal = ({ isOpen, onClose, retryMessage }) => {
  const analytics = useAnalytics();
  const viewEventFired = useRef(false);

  useEffect(() => {
    // useEffect for tracking page view analytic
    if (isOpen && !viewEventFired.current) {
      analytics.page("KYC", "KYC_Retry_Message_Viewed", { retryMessage });
      viewEventFired.current = true;
    }
  }, [isOpen, analytics, viewEventFired, retryMessage]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <FormattedMessage
            defaultMessage="There was an issue with the information you provided."
            description="User message"
          />
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <p>{retryMessage}</p>
          <p>
            <FormattedMessage
              defaultMessage="Please review your data and retry."
              description="User message"
            />
          </p>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            <FormattedMessage defaultMessage="Close" description="Button text" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RetryModal;
